import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Silently recover from an expired access token: on a 401, try the refresh
// endpoint once (using the 7-day refresh cookie) and replay the original request
// so in-progress work (e.g. saving a contact) is never lost to a lapsed session.
let refreshing = null;
const SKIP = ["/auth/login", "/auth/refresh", "/auth/logout"];

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;
    if (
      response && response.status === 401 && config && !config._retried &&
      !SKIP.some((p) => (config.url || "").includes(p))
    ) {
      config._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(config);
      } catch (e) {
        refreshing = null;
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
